<app-page-header
  title="FAQs verwalten"
  subtitle="Aktualisiere häufig gestellte Fragen und halte deine Kunden auf dem Laufenden."
  icon="help_outline"
  [showBackButton]="true"
  variant="gradient">
</app-page-header>

<div class="apple-container apple-slide-up">
  <div class="">
    <div class="apple-card faq-form-card">
      <div class="card-header-alignment">
        <div class="apple-icon-visual">
          <mat-icon>edit_note</mat-icon>
        </div>
        <div>
          <h2 class="apple-heading-3">
            {{ editingFaq ? 'FAQ bearbeiten' : 'Neue FAQ hinzufügen' }}
          </h2>
          <p class="apple-caption" style="line-height: 0;">
            Fülle die Felder aus und speichere deine Änderungen.
          </p>
        </div>
      </div>

      <form [formGroup]="faqForm" (ngSubmit)="saveFaq()" class="faq-form">
        <mat-form-field appearance="outline" class="apple-field">
          <mat-label>Frage</mat-label>
          <textarea matInput formControlName="question" required rows="1"></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="apple-field">
          <mat-label>Antwort</mat-label>
          <textarea matInput formControlName="answer" required rows="3"></textarea>
        </mat-form-field>
        <div class="faq-form-actions">
          <button
            mat-flat-button
            color="primary"
            class="apple-button apple-button-primary apple-button-large"
            style="font-size: 15px;"
            type="submit"
          >
            <mat-icon>save</mat-icon>
            {{ editingFaq ? 'FAQ aktualisieren' : 'FAQ hinzufügen' }}
          </button>
          <button
            mat-button
            type="button"
            class="apple-button apple-button-text"
            (click)="cancelEdit()"
            *ngIf="editingFaq"
          >
            <mat-icon>close</mat-icon>
            Abbrechen
          </button>
        </div>
      </form>
    </div>

    <div class="apple-card faq-table-card">
            <div class="card-header-alignment">

        <div class="apple-icon-visual">
          <mat-icon>library_books</mat-icon>
        </div>
        <div>
          <h2 class="apple-heading-3">FAQ Übersicht</h2>
          <p class="apple-caption" style="line-height: 0;">
            Bearbeite oder lösche bestehende Fragen.
          </p>
        </div>
      </div>
      <div class="table-wrapper">
        <table mat-table [dataSource]="(faqs$ | async) ?? []" class="apple-faq-table">
          <ng-container matColumnDef="question">
            <th mat-header-cell *matHeaderCellDef class="apple-table-header-cell">
              Frage
            </th>
            <td mat-cell *matCellDef="let faq" class="apple-table-cell">
              {{ faq.question }}
            </td>
          </ng-container>

          <ng-container matColumnDef="answer">
            <th mat-header-cell *matHeaderCellDef class="apple-table-header-cell">
              Antwort
            </th>
            <td mat-cell *matCellDef="let faq" class="apple-table-cell answer-cell">
              {{ faq.answer }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="apple-table-header-cell actions-header">
              Aktionen
            </th>
            <td mat-cell *matCellDef="let faq" class="apple-table-cell actions-cell">
              <button mat-icon-button class="apple-icon-button" (click)="startEdit(faq)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" class="apple-icon-button" (click)="deleteFaq(faq.id)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="apple-table-header-row"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" class="apple-table-row"></tr>
        </table>
      </div>
    </div>
  </div>
</div>
